import type { AppInfoMessage} from 'BrokerTsLib/src/dtos'
import { AppInfoMessageImportanceTypes } from 'BrokerTsLib/src/dtos'
import type { Product } from 'brokertslib/src/enums'
import type { IAvailableApps } from '../utils/availableApps'
import type { ICompany } from '../utils/companies'

export interface INewsItem {
  id: number
  app: IAvailableApps['appId']
  isActive?: boolean
  author?: string
  company?: ICompany['id']
  title: string
  tagLabel?: string
  date?: Date
  unread: boolean
  content?: string
  status: 'default' | 'success' | 'info' | 'warning' | 'danger'
  priority?: 'standard' | 'high'
  type?: 'info' | 'announcement' | 'warning' | 'outage'
}

export const getNewsItemTypeColor = (priority?: AppInfoMessageImportanceTypes) => {
  switch (priority) {
    case AppInfoMessageImportanceTypes.Standard: return 'green'
    case AppInfoMessageImportanceTypes.High: return 'red'
    case AppInfoMessageImportanceTypes.Unavailability: return 'blue'
    default: return 'green'
  }
}

export const NewsItemTypeColorMap = {
  info: 'blue',
  announcement: 'green',
  warning: 'orange',
  outage: 'red',
}

export const getNewsItemTypeColor_old = (type: keyof typeof NewsItemTypeColorMap | undefined) =>
  type && NewsItemTypeColorMap[type]

export const filterNewsByApp = (news: Array<AppInfoMessage>, app: Product) => {
  return news.filter((newItem) => newItem.insuranceCategoryType === app)
}

export const filterNewsByApp_old = (news: Array<INewsItem>, app: IAvailableApps['appId']) => {
  return news.filter((newItem) => newItem.app === app)
}